document.addEventListener('DOMContentLoaded', () => {
  const flipSlider = document.querySelector('.flip-slider');

  if (flipSlider) {
    const data = document.querySelector(`.swiper-data-handler`);
    const sectionId = data.dataset.section;
    const pagination = (data.dataset.pagination);
    const buttons = (data.dataset.buttons);
		const autoplay = (data.dataset.autoplay);
    const loop = (data.dataset.loop);
    let colsDesktop = Number(data.dataset.colDesktop);
    let colsDesktopXl = Number(data.dataset.colDesktopXl);
		let colsMobile = Number(data.dataset.colMobile);
		let colsTablet = Number(data.dataset.colTablet);
		const delay = Number(data.dataset.delay)*1000;
		const speed = Number(data.dataset.speed);

    const autoplayObj = {
			delay: delay,
			disableOnInteraction: true,
			pauseOnMouseEnter: true,
		};

    const swiperObject = {
      slidesPerView: colsMobile,
      speed: speed,
      spaceBetween: 20,
      breakpoints: {
				768: {
					slidesPerView: colsTablet,
          spaceBetween: 30,
				},
				1200: {
					slidesPerView: colsDesktop,
          spaceBetween: 33,
				},
        1600: {
          slidesPerView: colsDesktopXl,
          spaceBetween: 40,
        },
			},
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    }

    if (autoplay === 'true') {
			swiperObject.autoplay = autoplayObj;
		}

    if (loop === 'true') {
			swiperObject.loop = true;
		}
    
    let mySwiper = new Swiper('.flip', swiperObject);

    if (mySwiper) {
      window.addEventListener('resize', () => {
        mySwiper.destroy();
        mySwiper = new Swiper('.flip', swiperObject);
      });
    }
  }
});